import React from 'react';
import { Reveal } from './Reveal';
import { CTAButton } from './CTAButton';
export function UrgencySection() {
  return <section className="relative isolate overflow-hidden border-t border-gold-500/10 bg-void-900 py-24 md:py-28" data-id="element-225" data-mp="2sjucrlth3702">
      <div className="neon-grid pointer-events-none absolute inset-0 opacity-50" aria-hidden="true" data-id="element-226" data-mp="36bimxjk5vlee" />
      <div className="relative mx-auto max-w-3xl px-6 text-center" data-id="element-227" data-mp="31hxz2kca87sx">
        <Reveal data-id="element-228" data-mp="3g72i23qwig23">
          <h2 className="font-display text-3xl font-light leading-tight text-bone-50 sm:text-4xl md:text-[2.75rem]" data-id="element-229" data-mp="3g6u7wjm5xoul">
            La partida ya comenzó.{' '}
            <span className="neon-text text-gold-400" data-id="element-230" data-mp="3p8jy5m4b6hqs">
              ¿Vas a seguir mirando desde la banca?
            </span>
          </h2>
        </Reveal>
        <Reveal delay={0.08} data-id="element-231" data-mp="3l7zwq6cpcryu">
          <p className="mx-auto mt-7 max-w-2xl text-base leading-relaxed text-bone-300 sm:text-lg" data-id="element-232" data-mp="1uusqut9gc9yi">
            Cada día que pospones esta lectura es otro día repitiendo el mismo guion. Tu
            conciencia te está pidiendo otra cosa. Ya lo sabes.
          </p>
        </Reveal>
        <Reveal delay={0.14} data-id="element-233" data-mp="2srtmo9l7t17q">
          <CTAButton label="Entrar al juego" className="mt-10" data-id="element-234" data-mp="2xs7vvuyjyh7c" />
          <p className="mt-5 text-xs text-bone-500" data-id="element-235" data-mp="2xqochvhlnq1c">
            Acceso inmediato · Lectura para siempre · $9.990 CLP
          </p>
        </Reveal>
      </div>
    </section>;
}